export enum FormActions {
  Promise = 'Form action submit promise',
}
